import { useLocation } from "wouter";

export const useIsNationalSite = (): boolean => {
  const [location] = useLocation();
  return location.startsWith("/national");
};
